export default ({ request }) => ({
  ecomecomAmzSkuInvListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuInv/list',
      method: 'POST',
      data
    })
  },
  ecomecomAmzSkuInvFtyListApi(data = {}) {
    return request({
      url: '/ecom/ecomAmzSkuInv/fty/list',
      method: 'POST',
      data
    })
  },
  ecomecomAmzSkuInvExpandDetailApi(params = {}) {
    return request({
      url: '/ecom/ecomAmzSkuInv/expand/detail',
      method: 'GET',
      params
    })
  }
})
